import { NoResponse } from "@it-tc/legacy-api";

export default isNoResponse;
function isNoResponse(value: unknown): value is NoResponse {
  return (
    value !== null &&
    typeof value === "object" &&
    "responseCode" in value &&
    typeof value.responseCode === "string" &&
    "responseDescription" in value &&
    typeof value.responseDescription === "string"
  );
}
